import {cn} from '@ds/helpers';

type CustomDealInfoRowProps = {
  title: React.ReactNode;
  value: React.ReactNode;
  hasBorder?: boolean;
};

const CustomDealInfoRow: React.FC<CustomDealInfoRowProps> = ({title, value, hasBorder = true}) => {
  return (
    <div
      className={cn(
        'flex min-h-11 items-center justify-between gap-3 py-2 text-body-sm',
        hasBorder && 'border-b border-gray-02'
      )}
    >
      <span className="text-body-sm text-neutral-fg">{title}</span>
      <div className="shrink-0 text-body-sm text-neutral-fg">{value}</div>
    </div>
  );
};

export default CustomDealInfoRow;
